import {ChangeEvent} from "react";
import {useFormContext} from "react-hook-form";

import {IInputFieldProps, InputField as InputFieldDs} from "@pg-design/inputs-module";

import {IInputMaskStrategy, useInputMaskStrategy} from "../../hooks/use_input_mask_strategy";
import {inputMaskOnChangeWorkaround} from "../../utils/input_mask_on_change_workaround";

type IProps = Omit<IInputFieldProps, "name" | "error"> &
    Required<Pick<IInputFieldProps, "name">> & {
        mask?: IInputMaskStrategy;
    };

export function InputField(props: IProps) {
    const {name, mask: maskStrategy, ...fieldProps} = props;
    const {register, getFieldState, formState} = useFormContext<{[key: string]: unknown}>();
    const registeredInputProps = useInputMaskStrategy({
        register,
        name,
        strategy: maskStrategy,
        type: fieldProps.type
    });
    const fs = getFieldState(name, formState);

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (maskStrategy) {
            inputMaskOnChangeWorkaround(event);
        }
        if (fieldProps.onChange) {
            fieldProps.onChange(event);
        } else {
            return registeredInputProps.onChange?.(event);
        }
    };

    return (
        <InputFieldDs
            {...registeredInputProps}
            error={fs.error?.message}
            name={name}
            {...fieldProps}
            onChange={onChange}
            disabled={formState.disabled || fieldProps.disabled}
        />
    );
}
import {ChangeEvent} from "react";
import {useFormContext} from "react-hook-form";

import {IInputFieldProps, InputField as InputFieldDs} from "@pg-design/inputs-module";

import {IInputMaskStrategy, useInputMaskStrategy} from "../../hooks/use_input_mask_strategy";
import {inputMaskOnChangeWorkaround} from "../../utils/input_mask_on_change_workaround";

type IProps = Omit<IInputFieldProps, "name" | "error"> &
    Required<Pick<IInputFieldProps, "name">> & {
        mask?: IInputMaskStrategy;
    };

export function InputField(props: IProps) {
    const {name, mask: maskStrategy, ...fieldProps} = props;
    const {register, getFieldState, formState} = useFormContext<{[key: string]: unknown}>();
    const registeredInputProps = useInputMaskStrategy({
        register,
        name,
        strategy: maskStrategy,
        type: fieldProps.type
    });
    const fs = getFieldState(name, formState);

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (maskStrategy) {
            inputMaskOnChangeWorkaround(event);
        }
        if (fieldProps.onChange) {
            fieldProps.onChange(event);
        } else {
            return registeredInputProps.onChange?.(event);
        }
    };

    return (
        <InputFieldDs
            {...registeredInputProps}
            error={fs.error?.message}
            name={name}
            {...fieldProps}
            onChange={onChange}
            disabled={formState.disabled || fieldProps.disabled}
        />
    );
}
